import { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

/**
 * The page is fetched on arrival rather than built into every page: it opens
 * the pairing channel, and route components here are not split, so a static
 * import put the room's wire code in front of every first paint.
 */
const PairPage = lazy(async () => ({
  default: (await import("@/components/pair/PairPage")).PairPage,
}));

/**
 * The phone's half of handing a room to a computer.
 *
 * Opened by the phone's camera from the QR the computer drew; the token in the
 * address is the channel the computer is listening on.
 */
export const Route = createFileRoute("/pair/$token")({
  head: () => ({ meta: [{ name: "robots", content: "noindex" }] }),
  component: PairRoute,
});

function PairRoute() {
  const { token } = Route.useParams();
  return (
    <Suspense fallback={null}>
      <PairPage token={token} />
    </Suspense>
  );
}
